import axios from "axios";

export const PRICE_SUMMARY_REQUEST =
  "PRICE_SUMMARY_REQUEST";

export const PRICE_SUMMARY_SUCCESS =
  "PRICE_SUMMARY_SUCCESS";

export const PRICE_SUMMARY_FAIL =
  "PRICE_SUMMARY_FAIL";


export const fetchPriceSummary =
  (restaurantId, items) =>
  async (dispatch) => {

    try {

      dispatch({
        type: PRICE_SUMMARY_REQUEST,
      });


      const response = await axios.post(
        `/api/restaurants/${restaurantId}/price-summary/`,
        {
          items,
        }
      );


      dispatch({
        type: PRICE_SUMMARY_SUCCESS,
        payload: response.data,
      });


      return response.data;

    } catch (error) {

      const message =
        error.response?.data?.detail ||
        error.response?.data ||
        error.message ||
        "Failed to calculate price";


      dispatch({
        type: PRICE_SUMMARY_FAIL,
        payload: message,
      });


      throw error;

    }

  };